// eslint-disable-next-line import/prefer-default-export
export const driverTripTabOptions = [
  { label: 'Abiertos', value: 'actives' },
  { label: 'Cerrados', value: 'in_actives' },
  { label: 'Todos', value: 'else' }
];
